(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = document.documentElement;
  const readJSON = id => { const el = document.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch { return null; } };
  const CFG = readJSON('bjt-config') || {};
  const store = {
    get(k, d) { try { const v = localStorage.getItem('bjt:' + k); return v === null ? d : JSON.parse(v); } catch { return d; } },
    set(k, v) { try { localStorage.setItem('bjt:' + k, JSON.stringify(v)); } catch {} }
  };

  /* ───────── placeholder art: drawn from the active palette until real photos are added ───────── */
  let uid = 0;
  const W = 800, H = 500;
  function rng(seed) { let s = (seed * 2654435761) >>> 0 || 1; return () => ((s = (s * 1664525 + 1013904223) >>> 0) / 4294967296); }
  function ridge(r, base, amp, steps = 64) {
    const ph = [r() * 6.28, r() * 6.28, r() * 6.28], fr = [1 + r() * 1.2, 2.4 + r() * 1.8, 5 + r() * 3];
    const pts = [];
    for (let i = 0; i <= steps; i++) {
      const t = i / steps * 6.283;
      pts.push([i / steps * W, base - amp * (0.55 * Math.sin(t * fr[0] + ph[0]) + 0.3 * Math.sin(t * fr[1] + ph[1]) + 0.15 * Math.sin(t * fr[2] + ph[2]))]);
    }
    return pts;
  }
  const line = pts => pts.map((p, i) => (i ? 'L' : 'M') + p[0].toFixed(1) + ',' + p[1].toFixed(1)).join('');
  const area = pts => line(pts) + `L${W},${H}L0,${H}Z`;
  const f = v => `style="fill:var(--${v})"`;
  const sky = id => `<defs><linearGradient id="${id}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" style="stop-color:var(--art-sky1)"/><stop offset="1" style="stop-color:var(--art-sky2)"/></linearGradient></defs><rect width="${W}" height="${H}" fill="url(#${id})"/>`;
  function roof(cx, y, w, h, color) {
    const l = cx - w / 2, rr = cx + w / 2;
    return `<path d="M${l - 22},${y} Q${l + 2},${y - 4} ${l + 16},${y - h} L${rr - 16},${y - h} Q${rr - 2},${y - 4} ${rr + 22},${y} Z" ${f(color)}/>`;
  }
  const scenes = {
    wall(r, id) {
      const far = ridge(r, 250, 50), mid = ridge(r, 300, 60), near = ridge(r, 350, 75, 80);
      let s = sky(id) + `<circle cx="${560 + r() * 160}" cy="${110 + r() * 50}" r="38" ${f('art-sun')} opacity=".85"/>`;
      s += `<path d="${area(far)}" ${f('art-far')}/><path d="${area(mid)}" ${f('art-mid')} opacity=".85"/><path d="${area(near)}" ${f('art-near')}/>`;
      const wl = near.map(p => [p[0], p[1] - 3]);
      s += `<path d="${line(wl)}" fill="none" style="stroke:var(--art-wall)" stroke-width="10" stroke-linejoin="round"/>`;
      s += `<path d="${line(wl.map(p => [p[0], p[1] - 7]))}" fill="none" style="stroke:var(--art-wall)" stroke-width="5" stroke-dasharray="5 6"/>`;
      for (let i = 4; i < near.length - 4; i++) {
        const [x, y] = near[i];
        if (y < near[i - 1][1] && y <= near[i + 1][1] && (i % 2 === 0 || y < 300)) {
          s += `<rect x="${x - 15}" y="${y - 36}" width="30" height="34" ${f('art-wall')}/><path d="M${x - 15},${y - 38} h30" style="stroke:var(--art-wall)" stroke-width="6" stroke-dasharray="5 4"/><rect x="${x - 4}" y="${y - 20}" width="8" height="12" rx="4" ${f('art-sky1')} opacity=".5"/>`;
        }
      }
      return s + `<path d="${area(ridge(r, 470, 22))}" ${f('art-wall')} opacity=".9"/>`;
    },
    palace(r, id) {
      let s = sky(id) + `<circle cx="${600 + r() * 100}" cy="120" r="34" ${f('art-sun')} opacity=".8"/>`;
      s += `<path d="${area(ridge(r, 300, 18))}" ${f('art-far')}/><rect x="0" y="360" width="${W}" height="140" ${f('art-stone')}/>`;
      s += `<rect x="190" y="346" width="420" height="20" style="fill:var(--art-stone);stroke:var(--art-mid)" stroke-width="2"/><rect x="220" y="330" width="360" height="18" style="fill:var(--art-stone);stroke:var(--art-mid)" stroke-width="2"/>`;
      s += `<rect x="250" y="268" width="300" height="62" ${f('art-red')}/>`;
      for (let x = 262; x < 545; x += 28) s += `<rect x="${x}" y="272" width="5" height="58" ${f('art-wall')} opacity=".35"/>`;
      s += roof(400, 272, 300, 34, 'art-gold') + `<rect x="270" y="222" width="260" height="20" ${f('art-red')}/>` + roof(400, 226, 220, 40, 'art-gold');
      return s + `<rect x="0" y="410" width="${W}" height="46" ${f('art-red')}/><rect x="0" y="402" width="${W}" height="12" ${f('art-gold')}/><rect x="0" y="456" width="${W}" height="44" ${f('art-near')}/>`;
    },
    temple(r, id) {
      let s = sky(id) + `<path d="${area(ridge(r, 380, 26))}" ${f('art-mid')}/>`;
      s += `<rect x="150" y="410" width="500" height="22" ${f('art-stone')}/><rect x="190" y="390" width="420" height="22" ${f('art-stone')}/><rect x="230" y="370" width="340" height="22" ${f('art-stone')}/>`;
      const tier = (y, w, h, dw, dh) => `<rect x="${400 - dw / 2}" y="${y}" width="${dw}" height="${dh}" ${f('art-red')}/><path d="M${400 - w},${y} Q${400 - w * .45},${y - h * .35} 400,${y - h} Q${400 + w * .45},${y - h * .35} ${400 + w},${y} Z" ${f('art-roof')}/>`;
      s += tier(330, 135, 46, 190, 40) + tier(278, 105, 40, 150, 22) + tier(230, 78, 40, 110, 20);
      return s + `<circle cx="400" cy="184" r="9" ${f('art-gold')}/><rect x="0" y="432" width="${W}" height="68" ${f('art-near')}/>`;
    },
    lake(r, id) {
      let s = sky(id) + `<path d="${area(ridge(r, 300, 30))}" ${f('art-far')}/>`;
      s += `<path d="M0,330 Q120,200 240,250 Q300,280 360,330 Z" ${f('art-mid')}/>`;
      s += roof(185, 222, 50, 18, 'art-gold') + `<rect x="168" y="222" width="34" height="24" ${f('art-red')}/>` + roof(185, 200, 34, 18, 'art-gold');
      s += `<rect x="0" y="330" width="${W}" height="170" ${f('art-water')}/>`;
      for (let i = 0; i < 6; i++) s += `<path d="M${60 + i * 120},${370 + (i % 3) * 30} h60" style="stroke:var(--art-stone)" stroke-width="2" opacity=".6"/>`;
      s += `<rect x="360" y="330" width="440" height="22" ${f('art-stone')}/>`;
      for (let x = 380; x < 800; x += 46) s += `<ellipse cx="${x}" cy="356" rx="15" ry="13" ${f('art-water')}/>`;
      return s;
    },
    plane(r, id) {
      let s = sky(id) + `<path d="${area(ridge(r, 330, 40))}" ${f('art-far')}/>`;
      s += `<path d="M0,380 L${W},380 L${W},${H} L0,${H}Z" ${f('art-mid')}/><path d="M330,380 L470,380 L${W},${H} L0,${H} Z" ${f('art-near')}/>`;
      for (let i = 0; i < 6; i++) { const t = i / 6, t2 = t + .07; s += `<path d="M${396 - t * 30},${380 + t * t * 120} L${404 + t * 30},${380 + t * t * 120} L${404 + t2 * 30},${380 + t2 * t2 * 120} L${396 - t2 * 30},${380 + t2 * t2 * 120}Z" ${f('art-stone')}/>`; }
      return s + `<g transform="translate(${430 + r() * 120},${110 + r() * 40}) rotate(-9) scale(1.7)" ${f('art-wall')}><path d="M0,20 L96,14 Q116,13 122,19 Q116,25 96,25 L0,25 Z"/><path d="M50,19 L28,44 L41,44 L74,20 Z"/><path d="M8,20 L0,3 L11,3 L24,19 Z"/></g>`;
    },
    hutong(r, id) {
      let s = sky(id) + `<circle cx="640" cy="${110 + r() * 40}" r="30" ${f('art-sun')} opacity=".8"/>`;
      s += `<rect x="0" y="232" width="${W}" height="210" ${f('art-mid')}/><rect x="0" y="222" width="${W}" height="16" ${f('art-wall')}/>`;
      s += `<path d="M300,250 L500,250 L520,272 L280,272Z" ${f('art-wall')}/><rect x="338" y="272" width="124" height="170" ${f('art-near')}/><rect x="350" y="290" width="100" height="152" ${f('art-red')}/><rect x="399" y="290" width="2" height="152" ${f('art-wall')}/><circle cx="388" cy="360" r="5" ${f('art-gold')}/><circle cx="412" cy="360" r="5" ${f('art-gold')}/>`;
      s += `<ellipse cx="300" cy="300" rx="13" ry="16" ${f('art-red')}/><ellipse cx="500" cy="300" rx="13" ry="16" ${f('art-red')}/>`;
      return s + `<rect x="660" y="250" width="14" height="190" ${f('art-wall')}/><circle cx="640" cy="230" r="70" ${f('art-near')} opacity=".95"/><circle cx="700" cy="250" r="55" ${f('art-near')}/><rect x="0" y="442" width="${W}" height="58" ${f('art-stone')}/>`;
    },
    map(r) {
      let s = `<rect width="${W}" height="${H}" ${f('art-stone')}/>`;
      for (let i = 1; i < 10; i++) s += `<path d="M${i * 80},0 V${H} M0,${i * 50} H${W}" style="stroke:var(--art-far)" stroke-width="1" opacity=".6"/>`;
      s += `<rect x="260" y="150" width="280" height="200" rx="40" fill="none" style="stroke:var(--art-mid)" stroke-width="3"/><rect x="320" y="200" width="160" height="100" rx="24" fill="none" style="stroke:var(--art-mid)" stroke-width="2"/>`;
      const pts = [[150, 400], [330, 300], [420, 240], [520, 160], [650, 90]];
      s += `<path d="${line(pts)}" fill="none" style="stroke:var(--art-red)" stroke-width="4" stroke-dasharray="2 10" stroke-linecap="round"/>`;
      pts.forEach(([x, y], i) => { s += `<circle cx="${x}" cy="${y}" r="${i === 4 ? 16 : 11}" ${f(i === 4 ? 'art-red' : 'art-wall')}/><circle cx="${x}" cy="${y}" r="4" ${f('art-stone')}/>`; });
      return s;
    },
    guide(r, id) {
      const rd = ridge(r, 330, 50);
      return sky(id) + `<path d="${area(rd)}" ${f('art-far')}/><path d="${line(rd.map(p => [p[0], p[1] - 3]))}" fill="none" style="stroke:var(--art-mid)" stroke-width="6"/><circle cx="400" cy="240" r="72" ${f('art-mid')}/><path d="M250,${H} Q256,350 400,336 Q544,350 550,${H} Z" ${f('art-near')}/>`;
    },
    gondola(r, id) {
      let s = sky(id) + `<path d="${area(ridge(r, 260, 70))}" ${f('art-mid')}/><path d="${area(ridge(r, 400, 60))}" ${f('art-near')}/><path d="M0,120 L${W},260" style="stroke:var(--art-wall)" stroke-width="3"/>`;
      [[240, 163], [520, 213]].forEach(([x, y]) => { s += `<path d="M${x},${y} v30" style="stroke:var(--art-wall)" stroke-width="4"/><rect x="${x - 34}" y="${y + 28}" width="68" height="56" rx="10" ${f('art-red')}/><rect x="${x - 26}" y="${y + 36}" width="52" height="20" rx="4" ${f('art-sky1')} opacity=".85"/>`; });
      return s;
    },
    food() {
      return `<rect width="${W}" height="${H}" ${f('art-stone')}/><circle cx="400" cy="260" r="170" ${f('art-sky1')}/><circle cx="400" cy="260" r="130" ${f('art-stone')}/><circle cx="360" cy="235" r="46" ${f('art-red')} opacity=".85"/><circle cx="440" cy="255" r="40" ${f('art-gold')} opacity=".9"/><circle cx="395" cy="305" r="36" ${f('art-near')} opacity=".8"/><path d="M640,90 L600,440 M670,90 L630,440" style="stroke:var(--art-wall)" stroke-width="8" stroke-linecap="round"/>`;
    },
    car(r, id) {
      return sky(id) + `<path d="${area(ridge(r, 300, 30))}" ${f('art-far')}/><rect x="0" y="360" width="${W}" height="140" ${f('art-mid')}/><path d="M180,350 L230,270 Q240,256 260,256 L540,256 Q560,256 575,272 L640,350 Z" ${f('art-wall')}/><rect x="150" y="340" width="520" height="70" rx="22" ${f('art-wall')}/><path d="M262,272 L380,272 L380,338 L222,338Z M400,272 L540,272 L600,338 L400,338Z" ${f('art-sky1')} opacity=".7"/><circle cx="270" cy="410" r="34" ${f('art-near')}/><circle cx="550" cy="410" r="34" ${f('art-near')}/>`;
    }
  };
  const showTags = root.dataset.preview === '1';
  function paintArt(fig) {
    if (fig.dataset.painted || fig.querySelector('img')) return;
    const kind = fig.dataset.art || 'wall', seed = +fig.dataset.seed || 1, id = 'sk' + (++uid);
    fig.insertAdjacentHTML('afterbegin', `<svg viewBox="0 0 ${W} ${H}" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false">${(scenes[kind] || scenes.wall)(rng(seed), id)}</svg>`);
    if (showTags && fig.dataset.need) fig.insertAdjacentHTML('beforeend', `<span class="art-tag"><svg class="i" aria-hidden="true"><use href="#i-camera"/></svg><span>实拍待提供：${fig.dataset.need}</span></span>`);
    fig.dataset.painted = '1';
  }
  $$('.art[data-art]').forEach(paintArt);

  /* ───────── preview banner: style switcher ───────── */
  $$('.pv-styles button').forEach(b => {
    b.setAttribute('aria-pressed', String(b.dataset.style === root.dataset.style));
    b.addEventListener('click', () => {
      root.dataset.style = b.dataset.style; store.set('style', b.dataset.style);
      $$('.pv-styles button').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
    });
  });

  /* ───────── header menu ───────── */
  const menuBtn = $('.menu-btn'), mnav = $('#mnav');
  if (menuBtn && mnav) menuBtn.addEventListener('click', () => { mnav.hidden = !mnav.hidden; menuBtn.setAttribute('aria-expanded', String(!mnav.hidden)); });

  /* ───────── tour grid filters (home) ───────── */
  const grid = $('#tours-grid');
  const finder = { want: null, time: null };
  const TIME_TAG = { half: 'half-day', full: 'full-day', multi: 'multi-day', layover: 'layover' };
  const WANT_LABEL = { wall: 'The Great Wall', city: 'City sights', both: 'Wall + city' };
  const TIME_LABEL = { half: 'Half day', full: 'Full day', multi: '2+ days', layover: 'Layover' };
  let tab = 'all';
  const tagsOf = c => (c.dataset.tags || '').split(' ');
  function matchFinder(c) {
    const t = tagsOf(c);
    if (finder.want === 'wall' && !t.includes('great-wall')) return false;
    if (finder.want === 'city' && !t.includes('city')) return false;
    if (finder.want === 'both' && !(t.includes('great-wall') && t.includes('city'))) return false;
    if (finder.time && !t.includes(TIME_TAG[finder.time])) return false;
    return true;
  }
  function renderGrid() {
    if (!grid) return;
    const cards = $$('.card', grid), limit = +grid.dataset.limit || 6;
    const usingFinder = finder.want || finder.time;
    let shown = 0;
    cards.forEach(c => {
      const ok = (tab === 'all' || tagsOf(c).includes(tab)) && matchFinder(c);
      const vis = ok && (usingFinder || tab !== 'all' || shown < limit);
      c.hidden = !vis; if (vis) shown++;
    });
    const empty = $('#tours-empty'); if (empty) empty.hidden = shown > 0;
    const note = $('#filter-note');
    if (note) {
      if (usingFinder) {
        const parts = [WANT_LABEL[finder.want], TIME_LABEL[finder.time]].filter(Boolean);
        note.hidden = false;
        note.innerHTML = `<span>Showing <b>${shown}</b> ${shown === 1 ? 'tour' : 'tours'} for <b>${parts.join(' · ')}</b></span><button type="button" data-clear>Clear</button>`;
      } else note.hidden = true;
    }
  }
  function finderCount() {
    if (!grid) return null;
    return $$('.card', grid).filter(matchFinder).length;
  }
  $$('#finder .chips').forEach(g => g.addEventListener('click', e => {
    const b = e.target.closest('.chip'); if (!b) return;
    const on = b.getAttribute('aria-pressed') !== 'true';
    $$('.chip', g).forEach(c => c.setAttribute('aria-pressed', 'false'));
    b.setAttribute('aria-pressed', String(on));
    finder[g.dataset.key] = on && b.dataset.v !== 'any' ? b.dataset.v : null;
    const n = finderCount(), out = $('#finder-out');
    if (out && n !== null) out.textContent = n ? `${n} private ${n === 1 ? 'tour' : 'tours'}` : 'No exact match. We can plan a custom day.';
  }));
  const finderGo = $('#finder-go');
  if (finderGo) finderGo.addEventListener('click', () => {
    if (finder.time === 'layover' && $('#layover')) { jump($('#layover')); return; }
    if (!grid) { location.href = finderGo.dataset.fallback || '/collections/all'; return; }
    tab = 'all'; $$('.tab').forEach(t => t.setAttribute('aria-pressed', String(t.dataset.f === 'all')));
    renderGrid(); jump($('#tours'));
  });
  $$('.tab').forEach(t => t.addEventListener('click', () => {
    tab = t.dataset.f; $$('.tab').forEach(x => x.setAttribute('aria-pressed', String(x === t))); renderGrid();
  }));
  document.addEventListener('click', e => {
    if (e.target.closest('[data-clear]')) {
      finder.want = finder.time = null; $$('#finder .chip').forEach(c => c.setAttribute('aria-pressed', 'false')); renderGrid();
    }
  });
  renderGrid();
  { const out = $('#finder-out'), n = finderCount(); if (out && n) out.textContent = `${n} private ${n === 1 ? 'tour' : 'tours'}`; }

  function jump(el) {
    if (!el) return;
    const hdr = $('.hdr'), off = (hdr ? hdr.offsetHeight : 0) + 8;
    scrollTo({ top: el.getBoundingClientRect().top + scrollY - off, behavior: 'smooth' });
  }

  /* ───────── layover calculator ───────── */
  const LAY = readJSON('lay-data');
  const hm = x => { x = ((x % 24) + 24) % 24; let h = Math.floor(x), m = Math.round((x - h) * 60); if (m === 60) { h = (h + 1) % 24; m = 0; } return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`; };
  if (LAY && $('#calc')) {
    const landSel = $('#c-land');
    for (let h = 0; h < 24; h++) for (const m of [0, 30]) { const o = document.createElement('option'); o.value = h + m / 60; o.textContent = `${String(h).padStart(2, '0')}:${m ? '30' : '00'}`; if (h === 8 && !m) o.selected = true; landSel.append(o); }
    const calc = () => {
      const air = $('#c-air').value, land = +landSel.value, len = +$('#c-len').value;
      const EXIT = +LAY.exit || 2, BACK = +LAY.back || 3;
      $('#c-len-v').textContent = `${len} h`;
      const use = Math.max(0, len - EXIT - BACK), start = land + EXIT;
      $('#c-tl').innerHTML = use <= 0 ? `<div class="t-none" style="flex:1">Too short to leave the airport</div>` : `<div class="t-buf" style="flex:${EXIT}">Exit</div><div class="t-use" style="flex:${use}">${use} h free</div><div class="t-buf" style="flex:${BACK}">Check-in</div>`;
      $('#c-times').innerHTML = `<span>Land ${hm(land)}</span>${use > 0 ? `<span>Out ${hm(start)}</span><span>Back ${hm(land + len - BACK)}</span>` : ''}<span>Fly ${hm(land + len)}</span>`;
      $('#c-sum').textContent = use > 0 ? `About ${use} hours outside the airport, from ${hm(start)}.` : 'This layover is too short to leave the airport comfortably.';
      const sd = start % 24;
      $('#c-fit').innerHTML = (LAY.tours || []).map(t => {
        const need = +t[air];
        let st, cls;
        if (use >= need && sd >= 6 && sd <= t.latest) { st = 'Likely fits'; cls = 'ok'; }
        else if (use >= need - 1 && sd >= 6 && sd <= t.latest + 1) { st = 'Tight, ask us'; cls = 'warn'; }
        else if (use >= need) { st = 'Wrong time of day'; cls = 'bad'; }
        else { st = 'Not enough time'; cls = 'bad'; }
        const name = t.url ? `<a href="${t.url}">${t.name}</a>` : t.name;
        return `<li><span>${name} <span class="muted mono" style="font-size:.8125rem">· ~${need} h</span></span><span class="st ${cls}">${st}</span></li>`;
      }).join('');
    };
    ['#c-air', '#c-land', '#c-len'].forEach(s => $(s).addEventListener('input', calc));
    calc();
  }

  /* ───────── tour page: price estimate ───────── */
  const book = $('#book');
  const bk = { ad: 2, ch: 0 };
  let TIERS = null;
  const fmt = n => 'USD ' + Number(n).toLocaleString('en-US');
  const fmtDate = v => v ? new Date(v + 'T12:00:00').toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }) : '';
  if (book) {
    try { TIERS = JSON.parse(book.dataset.tiers || 'null'); } catch { TIERS = null; }
    if (Array.isArray(TIERS)) TIERS = TIERS.length ? Object.fromEntries(TIERS.map(x => [String(x.n), x.p])) : null;
    const maxTier = TIERS ? Math.max(...Object.keys(TIERS).map(Number)) : 10;
    const dateIn = $('#bk-date');
    const today = new Date(), iso = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    if (dateIn) dateIn.min = iso(today);
    const render = () => {
      const group = bk.ad + bk.ch, pp = TIERS ? TIERS[String(group)] : null;
      $('#bk-ad').textContent = bk.ad; $('#bk-ch').textContent = bk.ch;
      $('[data-step="ad"][data-d="-1"]').disabled = bk.ad <= 1;
      $('[data-step="ch"][data-d="-1"]').disabled = bk.ch <= 0;
      $$('[data-step][data-d="1"]').forEach(b => b.disabled = group >= 20);
      const travelers = `${group} ${group === 1 ? 'traveler' : 'travelers'}`;
      const set = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
      set('bk-n-label', travelers);
      set('bk-pp', pp ? fmt(pp) : 'Ask us');
      set('mb-pp', pp ? fmt(pp) : 'Group quote');
      set('mb-u', pp ? `per person · ${travelers}` : `${travelers} · we'll send a price`);
      let rows = `<div><dt>Date</dt><dd>${fmtDate(dateIn && dateIn.value) || 'Choose a date'}</dd></div>`;
      if (pp) {
        rows += `<div><dt>Per person (group of ${group})</dt><dd>${fmt(pp)}</dd></div><div><dt>Adults × ${bk.ad}</dt><dd>${fmt(pp * bk.ad)}</dd></div>`;
        if (bk.ch) rows += `<div><dt>Children × ${bk.ch}</dt><dd>Price on reply</dd></div>`;
        rows += `<div class="tot"><dt>Estimated total${bk.ch ? ' (adults)' : ''}</dt><dd>${fmt(pp * bk.ad)}</dd></div>`;
      } else rows += `<div class="tot"><dt>Groups over ${maxTier}</dt><dd>Quote on reply</dd></div>`;
      $('#bk-sum').innerHTML = rows;
      $$('#ptable tr[data-n]').forEach(tr => tr.classList.toggle('sel', +tr.dataset.n === Math.min(group, maxTier + 1)));
    };
    $$('[data-step]').forEach(b => b.addEventListener('click', () => { bk[b.dataset.step] += +b.dataset.d; render(); }));
    if (dateIn) dateIn.addEventListener('input', () => {
      const err = $('#bk-date-err');
      if (dateIn.value && dateIn.value < iso(today)) { err.hidden = false; err.textContent = 'Please choose a date from today onwards.'; } else err.hidden = true;
      render();
    });
    render();
    const mbGo = $('#mb-go');
    if (mbGo) mbGo.addEventListener('click', () => jump($('#book')));
    const mbar = $('#mbar'), card = $('.book-card');
    if (mbar && card && 'IntersectionObserver' in window) new IntersectionObserver(es => es.forEach(en => mbar.classList.toggle('away', en.isIntersecting)), { threshold: 0.15 }).observe(card);
  }

  /* ───────── section nav highlight ───────── */
  const snavLinks = $$('.snav a[href^="#"]');
  if (snavLinks.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) snavLinks.forEach(a => a.classList.toggle('on', a.getAttribute('href') === '#' + en.target.id)); }), { rootMargin: '-40% 0px -55% 0px' });
    snavLinks.forEach(a => { const s = document.getElementById(a.getAttribute('href').slice(1)); if (s) io.observe(s); });
  }

  /* ───────── WhatsApp + inquiry sheet ───────── */
  const tourName = book ? book.dataset.tour : '';
  function waText(kind) {
    const brand = CFG.brand || 'there';
    if (kind === 'tour') {
      const d = $('#bk-date');
      return `Hello ${brand}!\nI'd like to check availability for:\n${tourName}\n\nDate: ${fmtDate(d && d.value) || '[date]'}\nTravelers: ${bk.ad} adult${bk.ad > 1 ? 's' : ''}${bk.ch ? `, ${bk.ch} child${bk.ch > 1 ? 'ren' : ''}` : ''}\nHotel: [hotel name]`;
    }
    if (kind === 'layover') {
      const air = $('#c-air'), land = $('#c-land'), len = $('#c-len');
      return `Hello ${brand}!\nI have a layover in Beijing and would like a tour.\n\nAirport: ${air ? air.value.toUpperCase() : '[airport]'}\nLanding: [date] at ${land ? hm(+land.value) : '[time]'}\nLayover: ${len ? len.value : '[hours]'} hours\nNext flight: [flight number]`;
    }
    if (kind === 'custom') return `Hello ${brand}!\nI'd like help planning a custom trip.\n\nDates: [dates]\nTravelers: [number]\nInterested in: [places]`;
    return `Hello ${brand}!\nI have a question about your tours.`;
  }
  const sheet = $('#inq-sheet');
  let lastFocus = null;
  function openSheet(opts = {}) {
    if (!sheet) return;
    lastFocus = document.activeElement;
    const note = $('#inq-note', sheet);
    if (note) { note.hidden = !opts.note; note.textContent = opts.note || ''; }
    const set = (sel, v) => { const el = $(sel, sheet); if (el && v !== undefined && v !== null && !el.value) el.value = v; };
    if (opts.kind === 'tour' && book) {
      set('#inq-tour', tourName);
      const d = $('#bk-date'); if (d && d.value) $('#inq-date', sheet).value = d.value;
      $('#inq-n', sheet).value = bk.ad + bk.ch;
    }
    if (opts.kind === 'custom') set('#inq-tour', 'Custom trip');
    if (opts.kind === 'layover') set('#inq-tour', 'Layover tour');
    sheet.hidden = false;
    const first = $('input:not([type="hidden"]), textarea', sheet); if (first) first.focus();
  }
  function closeSheet() { if (!sheet) return; sheet.hidden = true; if (lastFocus) lastFocus.focus(); }
  if (sheet) {
    $$('[data-close]', sheet).forEach(b => b.addEventListener('click', closeSheet));
    sheet.addEventListener('click', e => { if (e.target === sheet) closeSheet(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });
    if ($('[data-autopen]', sheet)) sheet.hidden = false;
    const form = $('form', sheet);
    if (form) form.addEventListener('submit', e => {
      const err = $('#inq-err', sheet), name = $('#inq-name', sheet), email = $('#inq-email', sheet);
      let msg = '';
      if (!name.value.trim()) msg = 'Please add your name.';
      else if (!email.value.trim() || !email.checkValidity()) msg = 'Please add a valid email so we can reply.';
      if (msg) { e.preventDefault(); err.hidden = false; err.textContent = msg; (name.value.trim() ? email : name).focus(); }
    });
  }
  document.addEventListener('click', e => {
    const wa = e.target.closest('[data-wa]');
    if (wa) {
      e.preventDefault();
      const num = (CFG.wa || '').replace(/[^\d]/g, '');
      if (num) window.open(`https://wa.me/${num}?text=${encodeURIComponent(waText(wa.dataset.wa))}`, '_blank', 'noopener');
      else if (sheet) openSheet({ kind: wa.dataset.wa, note: 'WhatsApp is coming soon. Please send us your inquiry here for now.' });
      else jump($('#contact_form'));
      return;
    }
    const iq = e.target.closest('[data-inquiry]');
    if (iq) { e.preventDefault(); if (sheet) openSheet({ kind: iq.dataset.inquiry }); else jump($('#contact_form')); return; }
    const cp = e.target.closest('[data-copy]');
    if (cp) {
      const el = document.getElementById(cp.dataset.copy); if (!el) return;
      const done = () => { const o = cp.innerHTML; cp.textContent = 'Copied'; setTimeout(() => { cp.innerHTML = o; }, 1400); };
      const fallback = () => { const r = document.createRange(); r.selectNodeContents(el); const s = getSelection(); s.removeAllRanges(); s.addRange(r); };
      try { navigator.clipboard.writeText(el.textContent.trim()).then(done, fallback); } catch { fallback(); }
    }
  });
})();
